import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { Header, Body, Typography } from "../styled";
import { format } from "date-fns";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Radio from "@mui/material/Radio";

const AppointmentOrder: FC = () => {
    return (
        <Box mt={1}>
            <Header>
                <Box display='flex' alignItems={'center'} mt={1}>
                    <Typography mr={5.5}>Приказ</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mb: 1}}
                    />
                    <Typography mr={1} ml={1}>&</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "100px", mb: 1}}
                    />
                    <Typography mr={1} ml={1}>Дата приказа</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px" }} 
                    />
                </Box>
                <Box display='flex' alignItems={'center'} mt={1}>
                    <Typography mr={3}>Принять:</Typography>
                    <TextField
                        label="Имя"
                        variant="outlined"
                        size="small"
                        sx={{width: "300px", mb: 1, ml: 1}}
                    />
                    <TextField
                        label="Фамилия"  
                        variant="outlined"
                        size="small"
                        sx={{width: "300px", mb: 1, ml: 1}}
                    />
                    <TextField
                        label="Отчество"
                        variant="outlined"
                        size="small"
                        sx={{ width: "300px", mb: 1, ml: 1 }} 
                    />
                </Box>
                <Box display='flex' alignItems={'center'} mt={1}>
                    <Box display='flex' flexDirection={"column"} >
                        <FormControlLabel
                            label="печатать паспортные данные"
                            control={<Checkbox defaultChecked />}
                        />
                        <FormControlLabel
                            label="печатать Уральский коэффицент"
                            control={<Checkbox defaultChecked />}
                        />
                        <FormControlLabel
                            label="печатать Уральский коэффицент + деньги"
                            control={<Checkbox defaultChecked />}
                        />
                        <FormControlLabel
                            label="печатать расчеты ФЗП с учетом объема работы"
                            control={<Checkbox defaultChecked />}
                        />
                    </Box>
                    <Box display="flex" alignItems="center" flexDirection={"column"} ml={2}>
                        <FormControlLabel
                            value="category"
                            control={<Radio />}
                            label="подпись Руководителя 1"
                        />
                        <FormControlLabel
                            value="category"
                            control={<Radio />}
                            label="подпись Руководителя 2"
                        />
                        <FormControlLabel
                            value="category"
                            control={<Radio />}
                            label="подпись Руководителя 3"
                        />
                    </Box>
                </Box>

                <Box display='flex' alignItems={'center'}>
                <Typography mr={1}>С</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1, mb: 1 }}
                    />
                    <Typography mr={1}>в</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                </Box>
                <Box display='flex'alignItems={'center'}>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", ml: 30.2, mb: 1 }}
                    />
                </Box>
                <Box display='flex' alignItems={'center'}>
                    <Typography mr={1}>кабинет</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", ml: 2.5, mb: 1, mr: 1}}
                    />
                    <button>
                        Оклад + Надбавки
                    </button>
                </Box>
                <Box display='flex' alignItems={'center'}>
                    <Typography mr={1}>должность</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                </Box>
                <Box display='flex' alignItems={'center'}>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "50px", mr: 1, mb: 1 }}
                    />
                    <Typography mr={1}>квалификационной категории</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                    <Typography mr={1}>специальность</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "400px", mr: 1 }}
                    />
                </Box>
                <Box display='flex' alignItems={'center'}>
                <Typography mr={1}>стаж работы по специальности</Typography>
                    <TextField
                        label="лет"
                        variant="outlined"
                        size="small"
                        sx={{width: "70px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        label="мес"
                        variant="outlined"
                        size="small"
                        sx={{width: "70px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        label="дн"
                        variant="outlined"
                        size="small"
                        sx={{width: "70px", mr: 1, mb: 1 }}
                    />
                    <Typography mr={1}>непрерывный стаж в здравоохранении</Typography>
                    <TextField
                        label="лет"
                        variant="outlined"
                        size="small"
                        sx={{width: "70px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        label="мес"
                        variant="outlined"
                        size="small"
                        sx={{width: "70px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        label="дн"
                        variant="outlined"
                        size="small"
                        sx={{width: "70px", mr: 1, mb: 1 }}
                    />
                </Box>
                <Box display='flex' alignItems={'center'}>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "400px", ml: 35.1, mb: 1 }}
                    />
                </Box>
            </Header>
            <Body>
                <Box display="flex" alignItems="center">
                    <Typography mr={1}>Дата окончания контракта, договора</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mb: 1, mr: 1 }} 
                    />
                </Box>
                <Box display="flex" alignItems="center">
                    <Typography mr={1}>Условия приема на работу</Typography>
                    <TextField
                        label="Дата приказа"
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1}}
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={1}>
                    <TextField 
                        label="Вид приема(н-р:испытательный срок)" 
                        focused 
                        sx={{ color: "#858585", width: "400px"}}
                    />
                    <TextField 
                        label="Основание" 
                        focused 
                        sx={{ color: "#858585", width: "400px"}}
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={1}>
                    <Typography mr={1}>Дата рождения</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mb: 1, mr: 1}}
                    />
                    <TextField
                        label="ИНН"
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mb: 1, mr: 1}}
                    />
                    <Typography mr={1}>Пенсионное страховое свидетельство</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "300px", mb: 1, mr: 1}}
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={1}>
                    <Typography mr={1}>Паспорт</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "300px", mb: 1, mr: 1}}
                    />
                    <Typography mr={1}>серия</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "70px", mb: 1, mr: 1}}
                    />
                    <Typography mr={1}>-</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "70px", mb: 1, mr: 1}}
                    />
                    <Typography mr={1}>№</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "70px", mb: 1, mr: 1}}
                    />
                    
                </Box>
                <Box display="flex" alignItems="center" mt={1}>
                    <Typography mr={1}>выдан</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1, ml: 2}}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mb: 1, mr: 1}}
                    />
                    <TextField
                        label="подразделение"
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mb: 1, mr: 1}}
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={1}>
                    <Typography sx={{mb: 1, ml: 1,fontSize: 20}}> Адрес по паспорту: </Typography>
                </Box>
                <Box display="flex" alignItems="center" mt={2}>
                    <Typography mr={1}>район</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "400px", mb: 1, mr: 1, ml: 2}}
                    />
                    <Typography mr={1}>город, село</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "400px", mb: 1, mr: 1}}
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={1}>
                    <Typography mr={1}>ул.</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "400px", mb: 1, mr: 1, ml: 5}}
                    />
                    <Typography mr={1}>дом,кв</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mb: 1, mr: 1, ml: 4.6}}
                    />
                    <Typography mr={1}>дата регистрации</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mb: 1, mr: 1}}
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={1}>
                    <Typography mr={1}>индекс</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "400px", mb: 1, mr: 1, ml: 1}}
                    />
                    <Typography mr={1}>телефон</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "400px", mb: 1, mr: 1, ml: 3.2}}
                    />
                </Box>
            </Body>
        </Box>
    );
};

export default AppointmentOrder;

